import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { HIDE_BOT_ACTIONS, restartBot } from '../../../actions/botsActions';
import { Chip } from '@material-ui/core';
import { AlertCircle as AlertIcon } from 'react-feather';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next'
function BotOperations() {
  const { botId } = useParams();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation('common')

  const showBotActions = useSelector(state => state.bots.showBotActions);

  const handleSave = () => {
    restartBot(botId);
    dispatch({ type: HIDE_BOT_ACTIONS });
    enqueueSnackbar(t('resetBot'), {
      variant: 'success'
    })
  };

  if (showBotActions) {
    return (
      <div style={{ position: 'absolute', right: '24px', bottom: '24px' }}>
        <Chip
          style={{ height: 33 }}
          icon={<AlertIcon />}
          label={`${botId} needs to restart, click here`}
          color="secondary"
          clickable={true}
          onClick={handleSave}
          size={'medium'}
        />
      </div>
    );
  }
  return <></>;
}

BotOperations.propTypes = {
  className: PropTypes.string
};

export default BotOperations;
